export const ADD_POKEMONS = 'ADD_POKEMONS'
export const DELETE_POKEMON = 'DELETE_POKEMON'
export const ORDER_FOR_TYPE = 'ORDER_FOR_TYPE'
export const FILTER_FOR_L = 'FILTER_FOR_L'
export const FILTER_FOR_A = 'FILTER_FOR_A'
export const ORDER_FOR_ORIGIN = 'ORDER_FOR_ORIGIN'
export const RESET_STATE = 'RESET_STATE'
export const POKEMONS_SEARCH = 'POKEMONS_SEARCH'
export const IS_LOADING = 'IS_LOADING'
export const ADD_TYPES = 'ADD_TYPES'